import React, { useState, useRef, useEffect } from 'react';
import './ThumbnailWithActions.css';
import HtmlIcon from './HtmlIcon'

const ThumbnailWithActions = ({ type, name, url, imageClass, auth, tType  }) => {
  const [showActions, setShowActions] = useState(false); // State for showing actions
  const thumbnailRef = useRef(null); // Ref for the thumbnail container
  const actionsRef = useRef(null); // Ref for the action buttons container

  // Function to handle click outside the thumbnail or action buttons
  const handleClickOutside = (event) => {
    if (
      thumbnailRef.current && !thumbnailRef.current.contains(event.target) && 
      actionsRef.current && !actionsRef.current.contains(event.target)
    ) {
      setShowActions(false); // Hide actions if click is outside
    }
  };

  // Function to handle escape key press to hide actions
  const handleEscapeKey = (event) => {
    if (event.key === 'Escape') {
      setShowActions(false); // Hide actions when escape key is pressed
    }
  };

  // Set up event listeners for click outside and escape key
  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    document.addEventListener('keydown', handleEscapeKey);

    return () => {
      document.removeEventListener('click', handleClickOutside);
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, []);

  // Toggle the action buttons when the thumbnail is clicked
  const handleThumbnailClick = () => {
    setShowActions(!showActions);
  };

  return (
    <div 
      className="thumbnail-container" 
      onClick={handleThumbnailClick} 
      ref={thumbnailRef} 
      style={{ 
        position: 'relative', 
        cursor: 'pointer', 
        width: '150px', // Adjust width as needed
        height: '150px', // Adjust height as needed
      }}
    >
      {/* Render based on type (image or html) */}
       {/*
          style={{ 
            width: '100%', 
            height: '100%', 
            objectFit: 'cover' 
          }} 
        */}

      {type === 'image' ? (
        <img 
          className={imageClass} 
          src={url} 
          alt={name} 
        />
      ) : (<HtmlIcon filename={name} auth={auth} tType={tType}/>)}
      <div 
        className="resource-name" 
        style={{ 
          textAlign: 'center', 
          marginTop: '10px', 
          fontSize: '10px', 
          color: '#333' 
        }}
      >
        {name}
      </div>

      {/* Action Buttons (Overlayed) */}
      {/*
      {showActions && (
        <div 
          ref={actionsRef} 
          className="action-buttons" 
          style={{
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '10px',
            backgroundColor: 'rgba(0, 0, 0, 0.7)', // Accent background when actions are visible
            color: 'white',
            zIndex: '10', // Ensure it's on top
            borderRadius: '8px', // Optional: Add rounded corners
          }}
        >
          <button 
            onClick={() => alert('Edit clicked')} 
            style={{ 
              padding: '5px 10px', 
              cursor: 'pointer', 
              backgroundColor: 'transparent', 
              border: '1px solid #fff', 
              color: '#fff',
            }}
          >
            Edit
          </button>
        
          <button 
            onClick={() => alert('Delete clicked')} 
            style={{ 
              padding: '5px 10px', 
              cursor: 'pointer', 
              backgroundColor: 'transparent', 
              border: '1px solid #fff', 
              color: '#fff',
            }}
          >
            Delete
          </button>      
        </div>
      )}
        */}
    </div>
  );
};

/*
(
       <div 
          className="html-icon" 
          style={{ 
            width: '100%', 
            height: '100%', 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            backgroundColor: 'lightgray' 
          }}
        >
          📄
        </div>
      )
*/
export default ThumbnailWithActions;

